const GA_ID = 'G-4F5ZN0G3MN';
const STORAGE_KEY = 'cookie-consent';

export const getCookieConsent = () => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch (error) {
    return null;
  }
};

export const setCookieConsent = (value) => {
  localStorage.setItem(STORAGE_KEY, value);
  if (value === 'accepted') {
    loadGoogleAnalytics();
    return;
  }
  document.cookie.split(';').forEach((cookie) => {
    const name = cookie.split('=')[0].trim();
    if (name.startsWith('_ga') || name === '_gid') {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    }
  });
};

export const loadGoogleAnalytics = () => {
  if (typeof window === 'undefined' || window.gtag) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { anonymize_ip: true });
};

export const initAnalyticsFromConsent = () => {
  if (getCookieConsent() === 'accepted') {
    loadGoogleAnalytics();
  }
};
